import MapFixed from 'Components/Map/MapFixed';
import { RouteWithStopsAndDriver } from 'Data/interfaces';
import { useGetDashboardRouteDetailQuery } from 'Data/services/dashbaordApi';
import React from 'react';
import { Spinner } from 'react-bootstrap';

interface ComponentProps {
    id: number
}
const RouteDirection: React.FC<ComponentProps> = ({ id }) => {

    const { data, isFetching } = useGetDashboardRouteDetailQuery({ id: id });

    if (isFetching) {
        return <div className='w-100 p-5 my-5 d-flex justify-content-center'><Spinner /></div>
    }


    const route: Partial<RouteWithStopsAndDriver> = data?.data || {};

    if (!route?.route_stops?.length) {
        return <MapFixed />
    }

    return (

        <MapFixed
            hasMarker={true}
            isDirection={true}
            route_id={Number(route?.id)}
            direction={{
                origin: {
                    id: Number(route.route_stops[0].id),
                    lat: parseFloat(route.route_stops[0].latitude),
                    lng: parseFloat(route.route_stops[0].longitude),
                    status: route.route_stops[0].status
                },
                destination: {
                    id: Number(route.route_stops[route.route_stops.length - 1].id),
                    lat: parseFloat(
                        route?.route_stops[
                            route?.route_stops.length - 1
                        ].latitude
                    ),
                    lng: parseFloat(
                        route.route_stops[
                            route.route_stops.length - 1
                        ].longitude
                    ),
                    status: route.route_stops[route.route_stops.length - 1].status
                },
                waypoints: route.route_stops
                    .slice(1, route.route_stops.length - 1)
                    ?.map(item => ({ id: item.id, lat: parseFloat(item.latitude), lng: parseFloat(item.longitude), status: item.status })),
                route_emergency_service: route?.route_emergency_service || [],
                route_emergency_stop: route?.route_emergency_stop || []
            }}
            isGestureHandling={true}
        />
    )
}
export default RouteDirection